module.exports = __webpack_public_path__ + "static/media/smspinigai-paskolos-lt.02d667b7.png";